// export const Baseurl = "http://localhost:4031";
// export const Baseurl = 'https://salontreatappapi.salontreat.com';
export const Baseurl = "https://testsalontreatappapi.dexterous.in";
